import "formBuilder/dist/form-builder.min.js";
import "src/decidim/decidim_awesome/forms/rich_text_plugin";
jQuery.fn.sortable = () => {
};
window.CustomFieldsBuilders = window.CustomFieldsBuilders || [];
$(() => {
  $(".awesome-edit-config .proposal_custom_fields_editor").each((_idx, el) => {
    const key = $(el).closest(".proposal_custom_fields_container").data("key");
    const configVar = $(el).closest(".proposal_custom_fields_container").data("var");
    window.CustomFieldsBuilders.push({
      el,
      key,
      var: configVar,
      config: {
        i18n: {
          locale: window.DecidimAwesome.currentLocale,
          location: window.DecidimAwesome.formBuilderLangsLocation
        },
        formData: $(`input[name="config[${configVar}][${key}]"]`).val(),
        disableFields: ["button", "file"],
        disabledActionButtons: ["save", "data", "clear"],
        disabledAttrs: [
          "access",
          "inline",
          "className"
        ],
        controlOrder: [
          "text",
          "textarea",
          "number",
          "date",
          "checkbox-group",
          "radio-group",
          "select",
          "autocomplete",
          "header",
          "paragraph"
        ],
        disabledSubtypes: {
          // default color as it generate hashtags in decidim (TODO: fix hashtag generator with this)
          text: ["color"],
          // disable default wysiwyg editors as they present problems
          textarea: ["tinymce", "quill"]
        }
      },
      instance: null
    });
  });
  $(document).on("formBuilder.create", (_event, idx, list) => {
    if (!list[idx]) {
      return;
    }
    $(list[idx].el).formBuilder(list[idx].config).promise.then(function(res) {
      list[idx].instance = res;
      list[idx].el.FormBuilder = res;
      $(list[idx].el).find(".loading-spinner").remove();
      $(document).trigger("formBuilder.created", [list[idx]]);
      if (idx < list.length) {
        $(document).trigger("formBuilder.create", [idx + 1, list]);
      }
    });
  });
  if (window.CustomFieldsBuilders.length) {
    $(document).trigger("formBuilder.create", [0, window.CustomFieldsBuilders]);
  }
  $("form.awesome-edit-config").on("submit", () => {
    window.CustomFieldsBuilders.forEach((builder) => {
      $(`input[name="config[${builder.var}][${builder.key}]"]`).val(builder.instance.actions.getData("json"));
    });
  });
});
